// extracted by mini-css-extract-plugin
module.exports = {"Tag":"Tag_Tag_67VGz","Tag__isRequired":"Tag_Tag__isRequired_1lDzW","Tag_button":"Tag_Tag_button_3KdOR","Tag_text":"Tag_Tag_text_UlARw"};